import React from 'react';
import './especialidade.css';
import parse from "html-react-parser";

const Especialidade = (props) => {
  const { titulo, imagemSrc, texto } = props;

  return (
    <div className="psico__especialidade">
      <div className="psico__especialidade-content">
        <div className="psico__especialidade-imagem">
          <img src={imagemSrc} alt={titulo} />
        </div>

        <div className="psico__especialidade-titulo">
          <h3>{titulo}</h3>
        </div>

        <div className="psico__especialidade-texto">
          <p>{parse(texto)}</p>
        </div>
      </div>
    </div>
  )
}

export default Especialidade
